import { render } from "./FileMessage.vue?vue&type=template&id=479957f7&scoped=true"
import script from "./FileMessage.vue?vue&type=script&lang=js"
export * from "./FileMessage.vue?vue&type=script&lang=js"

import "./FileMessage.vue?vue&type=style&index=0&id=479957f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479957f7"]])

export default __exports__